module.exports = "<div class=q-marg-vert-md name=operational-shift-times-summary> <div class=row> <div class=\"col-md-4 col-xs-12\"> <span class=q-tag> {%- day%} : </span> </div> <div class=\"col-md-8 col-xs-12\"> {%= time %} </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/dockConfigurations/html/dockNewEdit/html/opertionalshifttimes.html
// module id = 1277
// module chunks = 1